export default {
  mobile: '1024px',
  desktop: '1024px',
};
